module.exports = __webpack_public_path__ + "static/media/lmHow-It-works_ownthetestbank.44be8b90.png";